import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { callApi } from "../../ApiHelper/ApiHelper";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import ColumnChart from "../../components/comman/Charts/ColumnChart";
import ManpowerChart from "../../components/comman/Charts/ManpowerChart";
import DashboardEventCard from "../../components/comman/DashboardEventCard";
import MainHeading from "../../components/comman/MainHeading";
import CustomersIcon from "../../components/Icons/CustomersIcon";
import EmployeesIcon from "../../components/Icons/EmployeesIcon";
import OfficesIcon from "../../components/Icons/OfficesIcon";
import SitesIcon from "../../components/Icons/SitesIcon";
import VendorsIcon from "../../components/Icons/VendorsIcon";
import {
  saveUserDetails,
  updateFiltersStates,
} from "../../store/actions/UserActions";
import AttendanceDashboard from "./DashboardDataListingComponents/AttendanceDashboard";
import PaymentOverviewSummery from "./DashboardDataListingComponents/PaymentOverviewSummery";
import PendingBudgetRequests from "./DashboardDataListingComponents/PendingBudgetRequests";
import PendingGRN from "./DashboardDataListingComponents/PendingGRN";
import PendingInvoice from "./DashboardDataListingComponents/PendingInvoice";
import PendingLeaveRequests from "./DashboardDataListingComponents/PendingLeaveRequests";
import PendingPaymentTicketsTabWise from "./DashboardDataListingComponents/PendingPaymentTicketsTabWise";
import PendingPurchaseOrders from "./DashboardDataListingComponents/PendingPurchaseOrders";
import PendingPurchaseRequests from "./DashboardDataListingComponents/PendingPurchaseRequests";
import PendingSalaryTickets from "./DashboardDataListingComponents/PendingSalaryTickets";
import PendingStockout from "./DashboardDataListingComponents/PendingStockout";
import TopCardDashboard from "./TopCardDashboard";
import { formatAmount } from "../../utility/CommonFunctions";
import { TotalRevenueIcon } from "../../components/Icons/TotalRevenue";
import { TotalExpenditureIcon } from "../../components/Icons/TotalExpenditureIcon";
import BgBlurLoader from "../../components/Loaders/BgBlurLoader";

export default function AdminDashboard() {
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [pageLoading, setPageLoading] = useState(true);
  const [pageStates, setPageStates] = useState({
    dashboardData: [],
    birthday_list: [],
    anniversaryList: [],
    siteList: [],
    officeList: [],
    isLoadingSite: false,
    sortByDate: [
      moment().subtract(30, "days").format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
    ],
  });
  useEffect(() => {
    GetSiteList(2);
    GetEmployeeDetail();
    GetDashboardData();
    GetBirthday_Anniversary_Data();
  }, []);

  const GetEmployeeDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_profile;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        dispatch(saveUserDetails(response?.data));
      } else {
        toast.error(response?.message);
      }
    });
  };

  const GetDashboardData = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_dashboard_data;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          dashboardData: response?.data,
        }));
        setPageLoading(false);
      } else {
        setPageLoading(false);
      }
    });
  };

  const GetBirthday_Anniversary_Data = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_birthday_anniversary;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          birthday_list: response?.data?.employeesBirthday,
          anniversaryList: response?.data?.employeesWorkAnniversary,
        }));
      }
    });
  };

  const GetSiteList = (type, searchQuery = null) => {
    return new Promise((resolve) => {
      const API =
        apiUrl.get_site +
        `?type=${type === 2 ? "O%26M" : "office"}&pageSize=100` +
        (searchQuery ? `&search=${searchQuery}` : "");

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData =
              type === 2
                ? response.data?.site.map((item) => ({
                  value: item.id,
                  label: item.name,
                }))
                : [];
            setPageStates((prev) => ({
              ...prev,
              ...(type === 2
                ? { siteList: formattedData || [] }
                : { officeList: response.data?.site || [] }),
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const formatFull = (value) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
    }).format(value);

  const formatCompact = (value) => {
    value = Number(value);

    if (!value || value === 0) return "₹0";

    const abs = Math.abs(value);

    if (abs >= 10000000) return `₹${(value / 10000000).toFixed(2)}Cr`;
    if (abs >= 100000) return `₹${(value / 100000).toFixed(2)}L`;
    if (abs >= 1000) return `₹${(value / 1000).toFixed(2)}K`;

    return `₹${value}`;
  };

  return (
    <>
      {pageLoading && <BgBlurLoader />}
      <div className="content">
        <MainHeading
          title={"Dashboard"}
          sites={pageStates?.siteList}
          office={pageStates?.dashboardData?.office}
          setPageStates={setPageStates}
          getSite={GetSiteList}
          pageState={pageStates}
        />
        <div className="row">
          <TopCardDashboard
            title={"Total Employees"}
            count={
              pageStates?.dashboardData?.getDashboardCount?.totalEmployees || 0
            }
            icon={<EmployeesIcon />}
          />
          <TopCardDashboard
            title={"Total Customers"}
            count={
              pageStates?.dashboardData?.getDashboardCount?.totalCustomer || 0
            }
            icon={<CustomersIcon />}
          />
          <TopCardDashboard
            title={"Total Vendors"}
            count={
              pageStates?.dashboardData?.getDashboardCount?.totalVendor || 0
            }
            icon={<VendorsIcon />}
          />
          <TopCardDashboard
            title={"Total Offices"}
            count={
              pageStates?.dashboardData?.getDashboardCount?.totalOffice || 0
            }
            icon={<OfficesIcon />}
          />
          <TopCardDashboard
            title={"Total Sites"}
            count={
              pageStates?.dashboardData?.getDashboardCount?.totalSites || 0
            }
            icon={<SitesIcon />}
          />
          <TopCardDashboard
            title={"Total Revenue"}
            count={formatCompact(
              pageStates?.dashboardData?.transactionAmount?.creditAmount || 0
            )}
            icon={<TotalRevenueIcon />}
          >
            {formatFull(
              pageStates?.dashboardData?.transactionAmount?.creditAmount || 0
            )}
          </TopCardDashboard>
          <TopCardDashboard
            title={"Total Expenditure"}
            count={formatCompact(
              pageStates?.dashboardData?.transactionAmount?.debitAmount || 0
            )}
            icon={<TotalExpenditureIcon />}
          >
            {formatFull(
              pageStates?.dashboardData?.transactionAmount?.debitAmount || 0
            )}
          </TopCardDashboard>
        </div>
        <div className="row dash-cards row-gap-3">
          {/* Cash Inflow / Outflow Chart===========> */}
          {/* <div className="col-12 col-lg-8">
            <div className="card h-100">
              <div className="card-body h-100">
                <div className="card-head">
                  <h3 className="card-title">
                    Site Wise Cash Inflow vs Outflow
                  </h3>
                </div>
                <ColumnChart
                  categories={[
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                  ]}
                  series={[
                    {
                      name: "Cash Inflow",
                      data: [44, 55, 57, 56, 61, 58, 63, 60, 120],
                    },
                    {
                      name: "Cash Outflow",
                      data: [76, 85, 101, 98, 87, 105, 91, 114, 94],
                    },
                  ]}
                />
              </div>
            </div>
          </div> */}

          {/* Attendance Table */}
          <AttendanceDashboard siteId={filterDetails?.siteId} />



          {/* Birthday and work Anniversory */}
          <div className="col-12 col-lg-4">
            <div className="row">
              <DashboardEventCard
                title={"Birthday"}
                birthdayList={pageStates?.birthday_list}
              />

            </div>
          </div>

          {/* Pending Leave Requests */}
          <PendingLeaveRequests siteId={filterDetails?.siteId} />

          {/* Birthday and work Anniversory */}
          <div className="col-12 col-lg-4">
            <div className="row">

              <DashboardEventCard
                title={"Work Anniversary"}
                workList={pageStates?.anniversaryList}
              />
            </div>
          </div>

          {/* Manpower Chart==========> */}
          <div className="col-12 col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="card-head">
                  <h3 className="card-title">Manpower Distribution</h3>
                </div>
                <ManpowerChart />
              </div>
            </div>
          </div>



          {/* Company wise income Chart===========> */}
          {/* <div className="col-12 col-lg-12">
            <div className="card h-100">
              <div className="card-body h-100">
                <div className="card-head">
                  <h3 className="card-title">Total company-wise income</h3>
                  <a
                    type="button"
                    className="btn btn-outline-primary py-1"
                    href="/attendance"
                  >
                    View All
                  </a>
                </div>
                <ColumnChart
                  categories={[
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                  ]}
                  series={[
                    {
                      name: "Net Profit",
                      data: [44, 55, 57, 56, 61, 58, 63, 60, 120],
                    },
                    {
                      name: "Revenue",
                      data: [76, 85, 101, 98, 87, 105, 91, 114, 94],
                    },
                    {
                      name: "Free Cash Flow",
                      data: [76, 85, 99, 98, 87, 60, 91, 111, 36],
                    },
                  ]}
                />
              </div>
            </div>
          </div> */}

          <PendingInvoice siteId={filterDetails?.siteId} />

          <PendingPurchaseRequests siteId={filterDetails?.siteId} />

          <PendingPurchaseOrders siteId={filterDetails?.siteId} />

          <PendingBudgetRequests siteId={filterDetails?.siteId} />

          <PendingPaymentTicketsTabWise siteId={filterDetails?.siteId} />

          <PaymentOverviewSummery siteId={filterDetails?.siteId} />

          <PendingSalaryTickets siteId={filterDetails?.siteId} />

          <PendingGRN siteId={filterDetails?.siteId} />

          <PendingStockout siteId={filterDetails?.siteId} />
        </div>
      </div>
    </>
  );
}
